<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="add-item-form"
	*ngIf="itemFormGroup"
	[ngClass]="{ 'add-form-outline': !item, 'edit-form-outline': item }"
>
	<form [formGroup]="itemFormGroup">
		<mat-grid-list cols="7" rowHeight="80px">
			<mat-grid-tile class="role-edit-grid-padding" colspan="2">
				<mat-form-field
					floatLabel="always"
					class="full-width add-item-field item-edit-color-picker"
					subscriptSizing="dynamic"
				>
					<mat-label>{{ strings.PROJECT_LOCATION_COLOR_PLACEHOLDER }}</mat-label>
					<span *ngIf="colorSelected$ | async">
						<color-picker
							#colorPickerElement
							[alpha]="0.1"
							[format]="'hex'"
							formControlName="color"
							[options]="{
								showPalette: true,
								showSelectionPalette: false,
								showPaletteOnly: true,
								preferredFormat: 'hex',
								usedColors: usedColors,
								noAutoClose: true,
								palette: palette
							}"
							(hide)="handleColorPickerHide()"
						>
						</color-picker>
					</span>
					<input
						class="color-picker-placeholder"
						matInput
						name="color"
						hidden
						formControlName="color"
						automationId="locationColor"
					/>
					<button
						*ngIf="!(colorSelected$ | async)"
						mat-raised-button
						color="primary"
						(click)="displayColorPicker()"
						class="select-a-color-button"
					>
						{{ strings.PROJECT_SELECT_COLOR }}
					</button>
				</mat-form-field>
			</mat-grid-tile>
			<mat-grid-tile class="role-edit-grid-padding" colspan="5">
				<mat-form-field class="full-width add-item-field" subscriptSizing="dynamic">
					<mat-label>{{ strings.PROJECT_LOCATION_NAME_PLACEHOLDER }}</mat-label>
					<input
						matInput
						name="name"
						formControlName="name"
						automationId="locationName"
						[placeholder]="strings.PROJECT_LOCATION_NAME_PLACEHOLDER"
					/>
				</mat-form-field>
			</mat-grid-tile>
		</mat-grid-list>
	</form>

	<button-footer
		(buttonSaveOrClose)="handleItemEvent({ type: 'Save', event: $event })"
		[disabled]="!canSave()"
		[saveOrCloseButtonText]="strings.UICONTROL_TEXT_SAVE | uppercase"
	>
		<button
			leftButton
			mat-button
			color="warn"
			*ngIf="item"
			(click)="handleItemEvent({ type: 'Delete', event: $event })"
			automationId="delete"
		>
			{{ strings.UICONTROL_TEXT_DELETE | uppercase }}
		</button>
		<button
			middleButton
			mat-button
			color="primary"
			(click)="handleItemEvent({ type: 'Cancel', event: $event })"
			automationId="cancel"
		>
			{{ strings.UICONTROL_TEXT_CANCEL | uppercase }}
		</button>
	</button-footer>
</div>
